module.exports = __webpack_public_path__ + "static/assets/ef9c3b2d3b5efa9cca416a0b5dc063b5.svg";